import { FunctionComponent } from 'react';
import HeaderSection from '../../../../components/sections/HeaderSection/HeaderSection';
import { useAppDispatch, useAppSelector } from '../../../../../../redux/hooks';
import BaseSection from '../../../../components/sections/BaseSection/BaseSection';
import { ReactComponent as DudeIll } from '../../../../../../asset/images/not_found/dude_with_telescope_and_waves.svg';
import styles from './Empty.module.scss';
import classNames from 'classnames';
import DudeSection from '../../../../components/sections/DudeSection/DudeSection';
import NavigationLink from '../../../../../../components/links/NavigationLink/NavigationLink';
import { CLIENT_SUPPORT_CONTENT } from '../../../../data/clientSupport';
import { openModal } from '../../../../../../redux/slices/modal/slice';

interface EmptyProps {}

const Empty: FunctionComponent<EmptyProps> = () => {
  const dispatch = useAppDispatch();

  const handleOpenLoginModal = () => {
    dispatch(openModal(CLIENT_SUPPORT_CONTENT.modalId));
  };
  return (
    <>
      <HeaderSection title={`Past Events`} elementsToHide={['Avatar']} />

      <DudeSection>
        Looks like you haven’t attended any Constellation Dinners yet! Once you’ve joined a dinner, your past events
        will appear here. Until then, <b>keep an eye out for your next invitation</b> and get ready for great
        conversations and connections. If you need assistance or have any questions, feel free to{' '}
        <NavigationLink path="#" onClick={handleOpenLoginModal}>
          reach out to {CLIENT_SUPPORT_CONTENT.name}
        </NavigationLink>
        !
      </DudeSection>
    </>
  );
};

export default Empty;
